import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { mockData } from '../data/mock';
import { Button } from '../components/ui/button';
import { ArrowRight, Phone } from 'lucide-react';

const CTASection = () => {
  const { t, language } = useLanguage();

  // Enhanced Google Ads Conversion + GA4 Tracking
  const handleBookingClick = () => {
    try {
      const consentStatus = localStorage.getItem('cookieConsent');
      const hasConsent = consentStatus === 'all' || consentStatus === 'accepted';
      
      if (typeof window.gtag !== 'function' || !hasConsent) return;

      // Check if conversion already fired this session (double-click protection)
      const conversionFired = sessionStorage.getItem('booking_conversion_fired');
      
      if (!conversionFired) {
        // Fire Google Ads conversion (once per session)
        window.gtag('event', 'conversion', {
          'send_to': 'AW-17076406474/1470Cln77dsaEOLnvs4'
        });
        sessionStorage.setItem('booking_conversion_fired', 'true');
      }

      // Fire GA4 analytics event (every click)
      window.gtag('event', 'booking_click', {
        'event_category': 'engagement',
        'event_label': 'booking_cta',
        'value': 1
      });
    } catch {
      // Fail silently
    }
  };

  return (
    <section className="py-20 bg-neutral-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-red-500 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-red-600 rounded-full blur-3xl" />
      </div>

      <div className="container-custom relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            {language === 'de'
              ? 'Bereit für Ihren Erste-Hilfe-Kurs?'
              : 'Ready for your first aid course?'}
          </h2>
          <p className="text-xl text-neutral-300 mb-10">
            {language === 'de'
              ? 'Sichern Sie sich jetzt Ihren Platz und lernen Sie, Leben zu retten.'
              : 'Reserve your spot now and learn how to save lives.'}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={mockData.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleBookingClick}
              data-testid="cta-booking-button"
            >
              <Button
                size="lg"
                className="bg-red-600 hover:bg-red-700 text-white font-bold px-10 py-6 text-lg rounded-xl shadow-lg hover:shadow-xl transition-all group w-full sm:w-auto"
              >
                <span>{t('hero.cta')}</span>
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </a>
            <a href={`tel:${mockData.company.phone}`}>
              <Button
                variant="outline"
                size="lg"
                className="border-2 border-white text-white hover:bg-white hover:text-neutral-900 font-semibold px-10 py-6 text-lg rounded-xl w-full sm:w-auto"
              >
                <Phone className="mr-2 w-5 h-5" />
                <span>0159 0226 8861</span>
              </Button>
            </a>
          </div>

          <p className="mt-8 text-neutral-400 text-sm">
            {language === 'de'
              ? 'Montag-Sonntag • 09:00 - 16:30 Uhr • Düsseldorf Hauptbahnhof Nähe'
              : 'Monday-Sunday • 9:00 AM - 4:30 PM • Near Düsseldorf Main Station'}
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
